export default "__VITE_ASSET__BpYmz3Zs__"